export const PURPOSES = [
  {
    value: 'DEBT_CONSOLIDATION',
    label: 'Debt Consolidation',
  },
  {
    value: 'HOME_IMPROVEMENT',
    label: 'Home Improvement',
  },
  {
    value: 'MAJOR_PURCHASE',
    label: 'Major Purchase',
  },
  {
    value: 'MEDICAL',
    label: 'Medical Expenses',
  },
  {
    value: 'RELOCATION',
    label: 'Moving/Relocation',
  },
  {
    value: 'VACATION',
    label: 'Vacation',
  },
  {
    value: 'SPECIAL_OCCASION',
    label: 'Special Occasion (Wedding Expenses)',
  },
  {
    value: 'OTHER',
    label: 'Other Personal Use',
  },
];
